import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Benefits.css';

const Benefits: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const benefits = [
    {
      icon: '🎯',
      title: 'Credibilidade Instantânea',
      description: 'Clientes confiam 75% mais em empresas com site profissional. Seja encontrado e respeitado no mercado.',
    },
    {
      icon: '📈',
      title: 'Geração de Leads',
      description: 'Capture leads qualificados 24/7 com landing pages otimizadas para conversão e formulários estratégicos.',
    },
    {
      icon: '🌍',
      title: 'Alcance Ampliado',
      description: 'Expanda sua presença além do físico. Mostre seus produtos e serviços para o mundo inteiro.',
    },
    {
      icon: '📱',
      title: 'Mobile First',
      description: '80% dos usuários acessam via mobile. Seu site será perfeito em qualquer dispositivo.',
    },
    {
      icon: '🚀',
      title: 'Performance Otimizada',
      description: 'Sites rápidos geram mais leads. Carregamento em menos de 3 segundos garantido.',
    },
    {
      icon: '📋',
      title: 'Catálogo Digital',
      description: 'Apresente seus produtos e serviços de forma organizada e atrativa, facilitando a decisão de compra.',
    },
  ];

  return (
    <section id="beneficios" className="benefits section">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="benefits-header"
        >
          <h2 className="section-title">
            Vantagens de Ter um Site Profissional
          </h2>
          <p className="section-subtitle">
            A Genesys Sistemas transforma seu negócio com sites profissionais que geram leads qualificados. 
            Desenvolvimento web especializado em sites institucionais, landing pages e catálogos digitais.
          </p>
        </motion.div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="benefit-card"
            >
              <div className="benefit-icon">
                {benefit.icon}
              </div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="benefits-cta"
        >
          <div className="urgency-box">
            <h3>⚡ Não perca mais tempo!</h3>
            <p>Cada dia sem um site profissional é credibilidade perdida. Seus concorrentes já estão online.</p>
            <div className="bonus-offer">
              <span className="bonus-text">🎁 BÔNUS: Hospedagem grátis por 1 mês!</span>
            </div>
            <a href="#contato" className="btn-primary">
              Quero Meu Site Agora
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;